"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interface = _interopRequireDefault(require("./interface"));
// 倒入所有接口

var _install = function install(Vue) {
  if (_install.installed) return;
  _install.installed = true;
  Object.defineProperties(Vue.prototype, {
    // 注意哦，此处挂载在 Vue 原型的 $api 对象上
    $api: {
      get: function get() {
        return _interface.default;
      }
    }
  });
};
var _default = exports.default = _install;